<template>
  <div class="eventSchedule">
    <Breadcrumb />
    <el-main>
      <EventDesc />
      <el-row class="nofull event_content">
        <EventMenu :menuActiveId="menuActiveId" />
        <el-main>
          <div class="contentEmpty" v-if="false">暂无内容</div>
          <div v-else class="muContent">
            <p>中国经济学年会秘书处联系方式：</p>
            <p>地 址：北京市海淀区北京大学（承泽园）国家发展研究院</p>
            <p>邮 编：100871</p>
            <p>联系人：中国经济学年会秘书处</p>
            <p>电 话：010-62759087</p>
            <p>Email: cea@pku.edu.cn</p>
          </div>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import EventDesc from '@/components/EventDesc.vue';
import EventMenu from '@/components/EventMenu.vue';

export default {
  name: 'EventContact',
  components: {
    Breadcrumb,
    EventDesc,
    EventMenu,
  },
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
  },
  mounted() {
    this.$emit('activeIndex', '5');
    this.$emit('pageClass', 'event');
  },
  data() {
    return {
      menuActiveId: '5',
    };
  },
  watch: {
    '$store.state.toGetCurrentEvent.currentEvent'(v) {
      document.title = '联系方式 - ' + v.name;
    },
  },
};
</script>

<style scoped></style>
